import { render, staticRenderFns } from "./Receptionist.vue?vue&type=template&id=10c68dfc&scoped=true&"
import script from "./Receptionist.vue?vue&type=script&lang=js&"
export * from "./Receptionist.vue?vue&type=script&lang=js&"
import style0 from "./Receptionist.vue?vue&type=style&index=0&id=10c68dfc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c68dfc",
  null
  
)

export default component.exports